import './product.component.scss'
import HolyStars from 'holy-stars'
import { ease } from '../../application/utils/ease'
import { Swiper, Pagination, Navigation } from 'swiper'
import { matchMedia } from '../../application/utils/machMedia'

Swiper.use(Pagination)
Swiper.use(Navigation)

const accordionItems = document.querySelectorAll('section.product .product-accordion-item__header')
function orientationChangeHandler() {
  Array.from(accordionItems).forEach(item => {
    if (item.classList.contains('is-active')) {
      const container = item.nextElementSibling
      ease.show(container)
    }
  })
}

function initStars() {
  const element = document.querySelector('.product-header-reviews__stars')
  if (element) {
    new HolyStars({
      el: document.querySelector('.product-header-reviews__stars'),
      rate: 5,
      size: 10,
      primaryColor: '#212b34',
      secondColor: '#ddd'
    })
  }
}
function setEase() {
  matchMedia('(orientation: portrait)')(orientationChangeHandler)
  Array.from(accordionItems).forEach(item => {
    item.addEventListener('click', () => {
      const toggleResult = item.classList.toggle('is-active')
      const container = item.nextElementSibling
      if (toggleResult) {
        ease.show(container)
      } else {
        ease.hide(container)
      }
    })
  })
}
function initSwiper() {
  const swiperElement = document.querySelector(
    '.product-media .swiper-container'
  )
  if (swiperElement) {
    new Swiper(swiperElement, {
      slidesPerView: 1,
      pagination: {
        el: '.product-media .swiper-pagination',
        type: 'bullets',
        clickable: true
      },
      navigation: {
        nextEl: '.swiper-custom-button-next',
        prevEl: '.swiper-custom-button-prev'
      }
    })
  }
}
function openAccordionItem() {
  const item = document.querySelector('.product-accordion-item .product-accordion-item__header:first-child')
  if (item) {
    const container = item.nextElementSibling
    ease.show(container)
    item.classList.add('is-active')
  }
}
initStars()
setEase()
initSwiper()
document.fonts.ready.then(openAccordionItem)
